import React from 'react';
import styled from 'styled-components';

import RichText from '../../../Global/RichText';
import List from '../../../Global/Lists';

import KuterLogo from '../../../../Images/footer/logo_kuter.png';
import KuterXx from '../../../../Images/footer/xx_kuter.svg';
import Vimeo from '../../../../Images/footer/vimeo.svg';
import Instagram from '../../../../Images/footer/instagram.svg';
import Facebook from '../../../../Images/footer/facebook.svg';
import SocialX from '../../../../Images/footer/x.svg';

import {
  Footer_Text,
  Legal_Title,
  Legal_List,
} from '../../../../utils/ES/Footer/index';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const FooterContainer = styled.div`
  width: 100%;
  background: #000;
  padding: 25px 40px 45px 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${breakpoints.mobile}) {
    padding: 20px 35px 20px 35px;
  }
`;

const KuterContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 185px;
  }

  img {
    width: 100%;
    max-width: 582px;
    display: block;

    @media (max-width: ${breakpoints.mobile}) {
      max-width: 185px;
    }
  }
`;

const LegalContainer = styled.div`
  padding-top: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-top: 0px;
  }

  li {
    transition: all 0.3s ease;
    &:hover {
      text-shadow: 0px 0px 10px rgba(255, 255, 255, 1);
      font-weight: 800;
    }

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 0.625rem;
      padding-left: 20px;
    }
  }
`;

const SocialContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.625rem;
  flex-direction: column;

  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

const SocialRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-out;

    &:hover svg {
      filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1));
    }
  }
`;

const Footer = () => {
  return (
    <>
      <FooterContainer id="footer">
        <KuterContainer>
          <img src={KuterLogo} alt="Kuter Logo" />
          <RichText dataText={Footer_Text} />
        </KuterContainer>
        <LegalContainer>
          <RichText dataText={Legal_Title} />
          <List
            dataList={Legal_List}
            cursor={'pointer'}
            textSize={'1.5rem'}
            marginBottom={'0.563rem'}
          />
        </LegalContainer>
        <SocialContainer>
          <KuterXx />
          <SocialRow>
            <a href="https://vimeo.com/kuter" target="_blank">
              <Vimeo />
            </a>
            <a href="https://www.instagram.com/kuter.tv" target="_blank">
              <Instagram />
            </a>
          </SocialRow>
          <SocialRow>
            <a
              href="https://www.facebook.com/kutermx/?locale=es_LA"
              target="_blank"
            >
              <Facebook />
            </a>
            <a href="https://x.com/Kuters" target="_blank">
              <SocialX />
            </a>
          </SocialRow>
        </SocialContainer>
      </FooterContainer>
    </>
  );
};

export default Footer;
